<div class="selector-div-wrapper">
  <span>Copy Link</span>
  <!-- <div class="selector-div">
    <select name="selector" class="selector" (change)="onSelect($event)" [(ngModel)]="tool.enabled">
      <option [ngValue]=true>Si</option>
      <option [ngValue]=false>No</option>
    </select>
    <div class="vertical-line"></div>
  </div> -->
  <div class="form-check form-switch">
    <input class="input-switch-sm form-check-input" type="checkbox" role="switch" id="copylink-switch"
      (change)="onSelect($event)" [(ngModel)]="tool.enabled" [checked]="tool.enabled">
  </div>
</div>